module.exports = __webpack_public_path__ + "img/moscow.b50147bd.jpg";